import React, { useId } from 'react';

const SPARK_PATH =
  'M12 1.5c.7 5.6 2.6 8 8.3 8.7.4.05.4 1.55 0 1.6-5.7.7-7.6 3.1-8.3 8.7-.05.4-1.55.4-1.6 0-.7-5.6-2.6-8-8.3-8.7-.4-.05-.4-1.55 0-1.6 5.7-.7 7.6-3.1 8.3-8.7.05-.4 1.55-.4 1.6 0Z';

/** Edge of the spark, in px: optically level with the 20px line icons beside it. */
const SIZE = 21;

/**
 * The AI Companion's mark in the Settings panel: a solid spark washed from
 * lilac to rose, the one filled glyph in a set of line icons. The gradient id is
 * per instance, since two panels can mount it at once while one slides out.
 */
const CompanionGradientSpark: React.FC = () => {
  // useId yields characters (":", "«") a url(#…) reference can trip on.
  const gradientId = `companion-spark-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;

  return (
    <svg width={SIZE} height={SIZE} viewBox="0 0 24 24" fill="none" aria-hidden>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--chakra-colors-lilac-600)" />
          <stop offset="55%" stopColor="var(--chakra-colors-nav-dark-ai-text)" />
          <stop offset="100%" stopColor="var(--chakra-colors-rose-300)" />
        </linearGradient>
      </defs>
      <path d={SPARK_PATH} fill={`url(#${gradientId})`} />
    </svg>
  );
};

export default CompanionGradientSpark;
